import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
// import { isMobile } from "@/utils/common";

// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  console.log("location", location);
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

// .保留模版2、3、6、8、10，序号不变，链接不变
// 2.删除模版1、4、5、7、9、11、12、13  14  15  16

const routes = [
  /** 首页 */
  {
    path: "/",
    name: "首页",
    component: () => import("@/views/Index.vue"),
  },
  // /** 模版1-PC */
  // {
  //   path: "/pc_template_1",
  //   alias: ["/:anything+/pc_template_1"],
  //   name: "PcTemplate1",
  //   component: () => import("@/views/PcTemplate1/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // /** 模版1-H5 */
  // {
  //   path: "/wap_template_1",
  //   alias: ["/:anything+/wap_template_1"],
  //   name: "WapTemplate1",
  //   component: () => import("@/views/WapTemplate1/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  //   meta: {
  //     isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
  //   },
  // },
  /** 模版2-PC */
  {
    path: "/pc_template_2",
    alias: ["/:anything+/pc_template_2"],
    name: "PcTemplate2",
    component: () => import("@/views/PcTemplate2/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      name: "模版2-PC",
    },
  },
  /** 新模版2-PC */
  {
    path: "/pc_template_new_2",
    alias: ["/:anything+/pc_template_new_2"],
    name: "PcTemplate2",
    component: () => import("@/views/PcTemplateNew2/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      name: "新模版2-PC",
    },
  },
  /** 模版2-H5 */
  {
    path: "/wap_template_2",
    alias: ["/:anything+/wap_template_2"],
    name: "WapTemplate2",
    component: () => import("@/views/WapTemplate2/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
      name: "模版2-WAP",
    },
  },
  /** 模版3-PC */
  {
    path: "/pc_template_3",
    alias: ["/:anything+/pc_template_3"],
    name: "PcTemplate3",
    component: () => import("@/views/PcTemplate3/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  /** 模版3-H5 */
  {
    path: "/wap_template_3",
    alias: ["/:anything+/wap_template_3"],
    name: "WapTemplate3",
    component: () => import("@/views/WapTemplate3/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
    },
  },
  // /** 模版4-H5 */
  // {
  //   path: "/wap_template_4",
  //   alias: ["/:anything+/wap_template_4"],
  //   name: "WapTemplate4",
  //   component: () => import("@/views/WapTemplate4/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  //   meta: {
  //     isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
  //   },
  // },
  // /** 模版5-H5 */
  // {
  //   path: "/wap_template_5",
  //   alias: ["/:anything+/wap_template_5"],
  //   name: "WapTemplate5",
  //   component: () => import("@/views/WapTemplate5/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  //   meta: {
  //     isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
  //   },
  // },
  /** 模版6-PC */
  {
    path: "/pc_template_6",
    alias: ["/:anything+/pc_template_6"],
    name: "PcTemplate6",
    component: () => import("@/views/PcTemplate6/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  {
    path: "/wap_template_6",
    alias: ["/:anything+/wap_template_6"],
    name: "WapTemplate6",
    component: () => import("@/views/WapTemplate6/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
    },
  },
  /** 模版8-PC */
  {
    path: "/pc_template_8",
    alias: ["/:anything+/pc_template_8"],
    name: "PcTemplate8",
    component: () => import("@/views/PcTemplate8/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  /** 模版8-H5 */
  {
    path: "/wap_template_8",
    alias: ["/:anything+/wap_template_8"],
    name: "WapTemplate8",
    component: () => import("@/views/WapTemplate8/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
    },
  },
  // /** 模版9-H5 */
  // {
  //   path: "/wap_template_9",
  //   alias: ["/:anything+/wap_template_9"],
  //   name: "WapTemplate8",
  //   component: () => import("@/views/WapTemplate9/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  //   meta: {
  //     isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
  //   },
  // },
  /** 模版10-PC */
  {
    path: "/pc_template_10",
    alias: ["/:anything+/pc_template_10"],
    name: "PcTemplate10",
    component: () => import("@/views/PcTemplate10/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  /** 模版10-h5 */
  {
    path: "/wap_template_10",
    alias: ["/:anything+/wap_template_10"],
    name: "WapTemplate10",
    component: () => import("@/views/WapTemplate10/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  // /** 模版11-PC */
  // {
  //   path: "/pc_template_11",
  //   alias: ["/:anything+/pc_template_11"],
  //   name: "PcTemplate10",
  //   component: () => import("@/views/PcTemplate11/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // /** 模版11-h5 */
  // {
  //   path: "/wap_template_11",
  //   alias: ["/:anything+/wap_template_11"],
  //   name: "WapTemplate11",
  //   component: () => import("@/views/WapTemplate11/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // {
  //   path: "/pc_template_12",
  //   alias: ["/:anything+/pc_template_12"],
  //   name: "PcTemplate12",
  //   component: () => import("@/views/PcTemplate12/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // /** 模版12-h5 */
  // {
  //   path: "/wap_template_12",
  //   alias: ["/:anything+/wap_template_12"],
  //   name: "WapTemplate12",
  //   component: () => import("@/views/WapTemplate12/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // /** 模版13-PC */
  // {
  //   path: "/pc_template_13",
  //   alias: ["/:anything+/pc_template_13"],
  //   name: "PcTemplate13",
  //   component: () => import("@/views/PcTemplate13/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // /** 模版14-h5 */
  // {
  //   path: "/wap_template_14",
  //   alias: ["/:anything+/wap_template_14"],
  //   name: "WapTemplate14",
  //   component: () => import("@/views/WapTemplate14/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  // /** 模版15-问卷注册 */
  {
    path: "/pc_template_15",
    alias: ["/:anything+/pc_template_15"],
    name: "PcTemplate15",
    component: () => import("@/views/PcTemplate15/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  /** 模版15-h5 */
  {
    path: "/wap_template_15",
    alias: ["/:anything+/wap_template_15"],
    name: "WapTemplate15",
    component: () => import("@/views/WapTemplate15/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  /** 模版16-pc */
  {
    path: "/pc_template_16",
    alias: ["/:anything+/pc_template_16"],
    name: "PcTemplate12",
    component: () => import("@/views/PcTemplate16/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  /** 模版16-h5 */
  {
    path: "/wap_template_16",
    alias: ["/:anything+/wap_template_16"],
    name: "WapTemplate12",
    component: () => import("@/views/WapTemplate16/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
  {
    path: "/wap_template_17",
    alias: ["/:anything+/wap_template_17"],
    name: "WapTemplate17",
    meta: {
      needHeadJs: true,
    },
    component: () => import("@/views/WapAiGg/Index"),
    props: ({ params }) => ({ anything: params.anything }),
  },
   /** 模版2-H5 */
  {
    path: "/wap_template_18",
    alias: ["/:anything+/wap_template_18"],
    name: "WapTemplate2",
    component: () => import("@/views/WapTemplate18/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
      name: "模版18-WAP",
    },
  },
   {
    path: "/wap_template_test",
    alias: ["/:anything+/wap_template_test"],
    name: "WapTemplate2",
    component: () => import("@/views/WapTemplateTest/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
      name: "模版18-WAP",
    },
  },
  //WapTemplate19{}
  {
    path: "/wap_template_19",
    alias: ["/:anything+/wap_template_19"],
    name: "WapTemplate2",
    component: () => import("@/views/WapTemplate19/Index"),
    props: ({ params }) => ({ anything: params.anything }),
    meta: {
      isMobile: true, // 是否是移动端，移动端会自动把px转换成rem
      name: "模版19-WAP",
    },
  },
  /** 模版home-PC */
  // {
  //   path: "/pc_template_home",
  //   alias: ["/:anything+/pc_template_home"],
  //   name: "PcTemplateHome",
  //   component: () => import("@/views/PcTemplateHome/Index"),
  //   props: ({ params }) => ({ anything: params.anything }),
  // },
  {
    path: "*",
    name: "ERROR404",
    component: () => import("@/views/error404"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach(async (to, from, next) => {
  const id = to.query.id;
  const jumpGetConfig = to.path.indexOf("wap_template_17") !== -1;
  console.log(jumpGetConfig, "jumpGetConfig");
  // 存储动态创建的 script 标签，用于离开时移除
let dynamicScript = null;
  if (jumpGetConfig) {
     // 创建 script 标签
    dynamicScript = document.createElement('script');
    dynamicScript.type = 'text/javascript';

    // 方式1：执行内联 JS 代码（从路由元信息获取）
   
      dynamicScript.textContent = `     window._agl = window._agl || [];
        (function () {
            _agl.push(
                ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
            );
            (function () {
                var agl = document.createElement('script');
                agl.type = 'text/javascript';
                agl.async = true;
                agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(agl, s);
            })();
        })();
    `;
    // 添加到 head 中
    document.head.appendChild(dynamicScript);
    next();
    return;
  }
  if (id) {
    store
      .dispatch("configInfo/getConfigInfo", { id })
      .then(() => {
        // 自定义title
        const title = store.getters["configInfo/webParam"].title;
        document.title = title;
        //注册成功后是否跳转官网首页，1跳转，0不跳转，默认均跳转
        let jumpHomePage = store.getters["configInfo/webParam"].jumpHomepage || "1";
        let copyRight = store.getters["configInfo/webParam"].copyRight
          ? store.getters["configInfo/webParam"].copyRight.replace(/<br>/g, "\n")
          : "";
        store.commit("configInfo/updateJumpHomePage", jumpHomePage);
        store.commit("configInfo/updateCopyRight", copyRight);
        next();
      })
      .catch(() => {
        next("/404");
      });
    return;
  }

  if (process.env.NODE_ENV === "production" && !id && to.path !== "/404") {
    next("/404");
  } else {
    next();
  }
});

export default router;
